function assign(x, y) {
  for (var k in y) {
    if (y.hasOwnProperty(k)) {
      x[k] = y[k];
    }
  }
  return x;
}

module.exports = assign;



//////////////////
// WEBPACK FOOTER
// ../~/tcomb/lib/assign.js
// module id = 758
// module chunks = 0